import React, {useState} from "react";
import Modal from "../atoms/Modal";
import InputGroup from "../atoms/InputGroup";
import {Usestatemodal} from '../../context/AdminDashboard/SystemModalContext'
import BtnModal from "../atoms/BtnModal";
import {useConfigContext} from "../../pages/configs/ConfigContext";
import {API_BASE_URL} from "../../clases/request";
import {showToastByIsSuccess} from "../../tools/tools";

const AddWarrantyModal = () => {
    const {closeModal, modalState, addWarranty} = useConfigContext()
    const isOpen = modalState.mode === "add" && modalState.isOpen;
    const [count, setCount] = useState()
    const token = localStorage.getItem("token");

    async function onBtnClick() {
        showToastByIsSuccess(true,"شماره سریال های خواسته شده ساخته شد.")
        closeModal()
        // await addWarranty(count)
    }

    if (!isOpen) return null;
    return (<>
        <Modal title={"افزودن شماره گارانتی جدید"} closeModal={closeModal}>
            <div className="flex flex-col w-379 gap-3.6 mb-5">
                {/* <InputGroup/> */}
                <div className={`flex flex-col w-full `}>
                    <label
                        htmlFor="name"
                        className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                        تعداد افزایش شماره کارانتی
                    </label>
                    <div
                        className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-12.6">
                        <input
                            id={"number"}
                            placeholder={"مانند 130"}
                            className="bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full"
                            onChange={(event) => {
                                setCount(event.target.value)
                            }}

                            //   onChange={}
                        />
                    </div>
                </div>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end pt-5.5">
                <a className={`w-full bg-blue-200 text-white active:bg-emerald-600  text-center
                font-medium uppercase text-14 px-6 py-3 rounded-sm `}
                   href={`${API_BASE_URL}/system/add/${count}/${token}`}
                   onClick={onBtnClick}
                >

                    <p>
                        ذخیره تغییرات
                    </p>
                </a>
                {/*<BtnModal text={"ذخیره تغییرات"} accept={onBtnClick}/>*/}

            </div>
        </Modal>
    </>);
};

export default AddWarrantyModal;
